export const RECEIPT_SLICE_NAME = "receipt"
